export const PDT = {
  TYPE: {
    DN: 'dn',
    DNO: 'dno'
  }
}